import React, { useEffect, useState } from 'react';
import { getAuthHeaders, fetchUser } from '@/app/funcs/api';
import Link from 'next/link';
import { toast } from 'react-toastify';

const MyShortLinks = () => {
    const [Items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const fetchItems = async () => {
            const token = localStorage.getItem("token");
            try {
                const res = await fetch(`https://site.figmawya.com/api/shorturl/v1/getmylinks`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (!res.ok) {
                    throw new Error("Failed to fetch items");
                }

                const data = await res.json();
                setItems(data);
            } catch (error) {
                console.error("Error:", error);
            } finally {
                setLoading(false);
            }
        };

        // Fetch user data from API
        const fetchUserData = async () => {
            try {
                const userData = await fetchUser();
                setUser(userData);
            } catch (error) {
                console.error("Error fetching user data:", error);
                // Fallback to localStorage
                const localUserData = localStorage.getItem('user');
                if (localUserData) {
                    try {
                        const parsedUser = JSON.parse(localUserData);
                        setUser(parsedUser);
                    } catch (error) {
                        console.error("Error parsing user data from localStorage:", error);
                    }
                }
            }
        };

        fetchUserData();
        fetchItems();
    }, []);

    const copyToClipboard = async (url) => {
        try {
            await navigator.clipboard.writeText(url);
            toast.success("تم نسخ الرابط بنجاح!");
        } catch (err) {
            console.error('Failed to copy: ', err);
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = url;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            toast.success("تم نسخ الرابط بنجاح!");
        }
    };

    // Get user's username/slug for branded links
    const getUserIdentifier = () => {
        if (!user) {
            return null;
        }
        
        // Try different possible username fields in order of preference
        const identifier = user.slug || user.user_login || user.username || user.user_nicename || user.name?.toLowerCase().replace(/\s+/g, '');
        
        return identifier;
    };

    if (loading) return <p>Loading...</p>;
    return (
        <div id='myLinks' className='card max-w-md p-4 rounded-4 shadow-sm mb-2 userAcountSection'>
            <h2><i className='bi bi-link-45deg'></i> الراوبط المختصرة</h2>
            
            {/* Help text */}
            <div className='alert alert-info small mb-3'>
                <i className='bi bi-info-circle me-2'></i>
                <strong>رابط سريع:</strong> رابط مختصر مباشر للرابط الأصلي
                <br />
                <strong>رابط مخصص:</strong> رابط يحتوي على اسم المستخدم ويظهر صفحة الملف الشخصي
            </div>
            
            <ul>
                {Items.map(i => {
                    const shortUrl = `https://figmawya.com/lnk/${i.post_title}`;
                    const userIdentifier = getUserIdentifier();
                    const brandedUrl = userIdentifier ? `https://figmawya.com/@${userIdentifier}/lnk/${i.post_title}` : null;
                    
                    return (
                        <li key={i.id} className='d-block border mb-3 btn btn-light'>
                            <div className='d-flex flex-column w-100'>
                                {/* Link Title */}
                                <div className='d-flex justify-content-between align-items-start mb-2'>
                                    <Link href={`../lnk/${i.post_title}`} className='d-block flex-grow-1 text-decoration-none text-dark'>
                                        <b className='d-block'> {i?.post_content ? i?.post_content : i.post_title}</b>
                                    </Link>
                                </div>
                                
                                {/* Quick Link Section */}
                                <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-2 p-2 bg-light rounded gap-2'>
                                    <div className='d-flex align-items-center gap-2 flex-grow-1 min-w-0'>
                                        <span className='badge bg-secondary flex-shrink-0'>رابط سريع</span>
                                        <span className='small text-break' style={{ wordBreak: 'break-all' }}>{shortUrl}</span>
                                    </div>
                                    <button
                                        onClick={(e) => {
                                            e.preventDefault();
                                            copyToClipboard(shortUrl);
                                        }}
                                        className='btn btn-sm btn-outline-secondary flex-shrink-0'
                                        title="نسخ الرابط السريع"
                                    >
                                        <i className='bi bi-clipboard'></i>
                                    </button>
                                </div>
                                
                                {/* Branded Link Section */}
                                {brandedUrl && (
                                    <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center p-2 bg-light rounded gap-2'>
                                        <div className='d-flex align-items-center gap-2 flex-grow-1 min-w-0'>
                                            <span className='badge bg-primary flex-shrink-0'>رابط مخصص</span>
                                            <span className='small text-muted text-break' style={{ wordBreak: 'break-all' }}>{brandedUrl}</span>
                                        </div>
                                        <button
                                            onClick={(e) => {
                                                e.preventDefault();
                                                copyToClipboard(brandedUrl);
                                            }}
                                            className='btn btn-sm btn-outline-secondary flex-shrink-0'
                                            title="نسخ الرابط المخصص"
                                        >
                                            <i className='bi bi-person-badge'></i>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default MyShortLinks;
